import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Divider, Icon, List, Message } from 'semantic-ui-react';

import { PageRootWrapper } from '@/components/shared/PageRootWrapper';

export type Props = {
  intervalKey: 'password.reset' | 'activation';
  linkTo: string;
  errorCode: string | undefined;
};

export const TokenExpired: React.FC<Props> = ({
  intervalKey,
  linkTo,
  errorCode,
}) => {
  const { t } = useTranslation();
  const title = t(`pages.${intervalKey}.index.title`);

  return (
    <PageRootWrapper
      title={title}
      breadcrumbItems={[{ label: title }]}
      containerType="normal"
    >
      <Styled>
        <Message
          data-test="expired-error"
          negative={true}
          icon="warning sign"
          header={t(`text.${intervalKey}.expired.warning`)}
          content={t(`text.${intervalKey}.expired.description`)}
        />
        <Divider hidden={true} />
        {errorCode !== 'already_activated' && (
          <List>
            <List.Item>
              <Icon name="pointing right" />
              <List.Content>
                <Link to={linkTo}>
                  <List.Header className="link-text">
                    {t(`text.${intervalKey}.expired.link`)}
                  </List.Header>
                </Link>

                <List.Description>
                  {t(`text.${intervalKey}.expired.linkDescription`)}
                </List.Description>
              </List.Content>
            </List.Item>
          </List>
        )}
      </Styled>
    </PageRootWrapper>
  );
};

const Styled = styled.div`
  .ui.list > .item .header.link-text {
    color: #5281ff;
  }
`;
